module.exports = __webpack_public_path__ + "static/media/admin.239f1ae0.svg";